<nav [ngClass]="{'left-0': (sidenav.status | async)===false }" class="navbar flex-wrap navbar-expand-lg bg-white border-bottom fixed-top p-1">
    <div class="container-fluid">
        <button class="btn text-primary border-0 p-0 shadow-none" title="Toggle Menu" (click)="sidenav.toggle()">
            <span class="material-icons m-0">menu</span>
            <span class="visually-hidden">
                Toggle Menu
            </span>
        </button>
        <div class="d-flex nav-item" ngbDropdown display="dynamic" placement="bottom-right">
            <a class="nav-link dropdown-toggle d-flex align-items-center justify-content-center pb-2" ngbDropdownToggle>
                <app-avatar [userData]="userData"></app-avatar>
            </a>
            <ul ngbDropdownMenu class="b-dropdown" style="width: 256px;">
                <li>
                    <div class="d-flex p-2">
                        <div class="w-25">
                            <app-avatar [userData]="userData" [height]="48" [width]="48"></app-avatar>
                        </div>
                        <div class="flex-grow-1">
                            <div class="fw-bold text-nowrap text-truncate">{{userData.name}}</div>
                            <div class="text-nowrap text-truncate">{{userData.email}}</div>
                        </div>
                    </div>
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li>
                    <a class="dropdown-item" routerLink="/account">
                        <span class="material-icons">account_circle</span>
                        Account
                    </a>
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li>
                    <a class="dropdown-item btn-link" (click)="logout()">
                        <span class="material-icons">logout</span>
                        Logout
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <app-breadcrumb class="w-100"></app-breadcrumb>
</nav>
<ng-template #logoutModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Logout</h5>
    </div>
    <div class="modal-body">
        Are you sure want to logout?
    </div>
    <div class="modal-footer d-flex justify-content-between">
        <div>
            <div class="spinner-border text-primary" role="status" *ngIf="loading">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="text-end">
            <button type="button" class="btn btn-primary" (click)="modal.close()" [attr.disabled]="loading ? 'disabled' : null">Cancel</button>
            &nbsp;
            <button type="button" class="btn btn-secondary" (click)="goLogout()" [attr.disabled]="loading ? 'disabled' : null">Logout</button>
        </div>
    </div>
</ng-template>
